import { getJson, postJson } from "../../core/http";
import { localizedRawPath } from "../../core/localePaths";

export function signIn(payload) {
  return postJson(localizedRawPath("/login"), payload);
}

export function signUp(payload) {
  return postJson(localizedRawPath("/sign-up"), payload);
}

export function resendVerification(payload) {
  return postJson(localizedRawPath("/resend-verification"), payload).then(normalizeVerificationState);
}

export function verifyEmailOtp(payload) {
  return postJson(localizedRawPath("/verify-email-otp"), payload);
}

export function fetchEmailVerificationStatus() {
  return getJson(localizedRawPath("/email-verification-status")).then(normalizeVerificationState);
}

function normalizeVerificationState(payload) {
  const data = payload || {};
  return {
    ...data,
    verification_required: Boolean(data.verification_required),
    otp_active: Boolean(data.otp_active),
    otp_expires_in_seconds: Math.max(0, Number(data.otp_expires_in_seconds) || 0),
    resend_allowed: Boolean(data.resend_allowed),
    resend_available_in_seconds: Math.max(0, Number(data.resend_available_in_seconds) || 0),
    delivery_attempted: data.delivery_attempted === null || data.delivery_attempted === undefined ? null : Boolean(data.delivery_attempted),
    delivery_dispatched: data.delivery_dispatched === null || data.delivery_dispatched === undefined ? null : Boolean(data.delivery_dispatched)
  };
}
